import { ErrorResponseType } from "../types/api/main";
import { doDeleteRequest, doGetRequest, doPostRequest, doPutRequest } from "./mainAPI";
import { CENTER, POST } from "../constants/mainAPI";
import { toFormData } from "../utils/toFormData";
import { getFileFromUrl } from "../utils/getFileFromUrl";
import { PostsSuccessResponse, PostSuccessResponse } from "../types/api/post";

export const getPosts = (
    centerId: string | undefined,
    callback?: (resp: PostsSuccessResponse) => any,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
    searchParams?: Record<string, any>,
) => {
    return doGetRequest(`${CENTER}/${centerId || 0}/${POST}`, true, searchParams, callback, errorCallback);
};

export const getPost = (
    centerId: string | undefined,
    postId: number | undefined,
    callback?: (resp: PostSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    return doGetRequest(`${CENTER}/${centerId || 0}/${POST}/${postId}`, true, {}, callback, errorCallback);
};

export const createNewPost = async (
    centerId: string | undefined,
    data: any,
    callback?: (resp: PostSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    const formData = toFormData(data);
    if (data?.photos?.length > 1) {
        let promises = [] as any;
        await data.photos.forEach((v: any, index: Number) => {
            v &&
                promises.push(
                    getFileFromUrl(v.photo.file, v.photo.name).then(r => {
                        r && formData.append(`photos[${index}]`, r);
                    }),
                );
        });
        await Promise.all(promises).finally(() => {
            return doPostRequest(`${CENTER}/${centerId || 0}/${POST}`, true, formData, {}, callback, errorCallback);
        });
    } else {
        return doPostRequest(`${CENTER}/${centerId || 0}/${POST}`, true, formData, {}, callback, errorCallback);
    }
};

export const editPost = async (
    centerId: string | undefined,
    postId: number | undefined,
    data: any,
    callback?: (resp: PostSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    const formData = toFormData(data);
    if (data.delete_photos?.length > 0) {
        data.delete_photos.forEach((v: any, index: Number) => {
            formData.append(`delete_photos[${index}]`, v);
        });
    }
    if (data?.photos?.length > 1) {
        let promises = [] as any;
        await data.photos.forEach((v: any, index: Number) => {
            v?.photo?.file &&
                promises.push(
                    getFileFromUrl(v.photo.file, v.photo.name).then(r => {
                        r && formData.append(`photos[${index}]`, r);
                    }),
                );
        });
        await Promise.all(promises).finally(() => {
            return doPutRequest(
                `${CENTER}/${centerId || 0}/${POST}/${postId}`,
                true,
                formData,
                {},
                callback,
                errorCallback,
            );
        });
    } else {
        return doPutRequest(
            `${CENTER}/${centerId || 0}/${POST}/${postId}`,
            true,
            formData,
            {},
            callback,
            errorCallback,
        );
    }
};

export const deletePost = (
    centerId: string | undefined,
    postId: number | undefined,
    callback?: (resp: any) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    return doDeleteRequest(`${CENTER}/${centerId || 0}/${POST}/${postId}`, true, {}, callback, errorCallback);
};
